"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getRelationships = exports.fetchRelationshipsForDeletedIssueAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _fetchHelpers = require("../fetchHelpers");
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial,
  data: []
};
const relationshipsSlice = (0, _toolkit.createSlice)({
  name: "relationships",
  initialState,
  reducers: {
    relationshipsFetchStart(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
    },
    relationshipsFetchSuccess(state, action) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      state.data = action.payload;
    },
    relationshipsFetchError(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Error;
    }
  }
});
const {
  relationshipsFetchStart,
  relationshipsFetchSuccess,
  relationshipsFetchError
} = relationshipsSlice.actions;
const fetchRelationshipsForDeletedIssueAction = _ref => {
  let {
    issueId,
    onlyDeleted,
    deletedAfter
  } = _ref;
  return async (dispatch, getState, _ref2) => {
    let {
      sdk
    } = _ref2;
    dispatch(relationshipsFetchStart());
    try {
      const {
        relationships
      } = await sdk.Relationships.getAll({
        issueId,
        onlyDeleted,
        deletedAfter
      });
      dispatch(relationshipsFetchSuccess(relationships));
    } catch (e) {
      dispatch(relationshipsFetchError());
    }
  };
};
exports.fetchRelationshipsForDeletedIssueAction = fetchRelationshipsForDeletedIssueAction;
const reducer = exports.reducer = relationshipsSlice.reducer;
const STATE_KEY = exports.STATE_KEY = relationshipsSlice.name;
const getRelationshipsState = state => {
  return state[STATE_KEY];
};
const getRelationships = exports.getRelationships = (0, _toolkit.createSelector)(getRelationshipsState, state => state.data || []);
//# sourceMappingURL=relationships.js.map